// export const url = "https://xtratoys.nextechltd.in/api";
// export const url = "https://adscpos.nextechltd.in/api";

//export const url = "http://localhost:8001/api";

export const url = "https://everydaycpos.nextechltd.in/api";
export const isAdmin = true;

export const adminUrl = "https://everydaycpos.nextechltd.in/api";
